import axios from "axios/index";
import { loginURL } from "./urls/app";
import { signOut } from "./auth";
import { history } from "../shared/helpers/_history";
import * as utils from "./utils";

axios.defaults.withCredentials = true;

function isResponseSuccessful(response) {
  return response.status === 200 || response.status === 201;
}

export const GET = "get";
export const POST = "post";
export const PUT = "put";
export const PATCH = "patch";
export const DELETE = "delete";

/*
  responseType defaults to json.
  Pass "blob" only when downloading files.
*/
export function callService(
  method,
  url,
  data,
  successCallback,
  errorCallback,
  responseType = "json"
) {
  axios({
    method: method,
    url: url,
    data: data,
    responseType: responseType,
  })
    .then((response) => {
      if (isResponseSuccessful(response)) {
        successCallback(response);
      } else {
        errorCallback(response);
      }
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          if (utils.isUserAuthenticated()) {
            signOut();
            history.push({ pathname: loginURL });
          }
        } else if (error.response.status === 403) {
          errorCallback(error);
        } else {
          errorCallback(error);
        }
      } else {
        errorCallback(error);
      }
    });
}



// WEBPACK FOOTER //
// ./src/shared/serviceInvoker.js